import script from "./MobileChatHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./MobileChatHeader.vue?vue&type=script&setup=true&lang=ts"

import "./MobileChatHeader.vue?vue&type=style&index=0&id=f090ad64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f090ad64"]])

export default __exports__